import { Icon, IconProps } from "../";

export const NotebookCloseLineIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M17.7512 21.9983H6.24805C5.00586 21.9983 3.99805 20.9905 3.99805 19.7483V4.4999C3.99805 3.12178 5.11836 2.00146 6.49648 2.00146H18.4965C18.909 2.00146 19.2465 2.33896 19.2465 2.75146C19.2465 3.16396 18.909 3.50146 18.4965 3.50146H6.49648C5.94336 3.50146 5.49805 3.95146 5.49805 4.4999C5.49805 5.04834 5.94805 5.49834 6.49648 5.49834H17.7465C18.9887 5.49834 19.9965 6.50615 19.9965 7.74834V19.7483C20.0012 20.9905 18.9887 21.9983 17.7512 21.9983ZM5.49805 6.79209V19.753C5.49805 20.1655 5.83555 20.503 6.24805 20.503H17.7465C18.159 20.503 18.4965 20.1655 18.4965 19.753V7.75303C18.4965 7.34053 18.159 7.00303 17.7465 7.00303H6.49648C6.14492 6.99834 5.80742 6.92334 5.49805 6.79209Z" />
    </Icon>
  );
};
